import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const LeftNavigation = function LeftNavigation(props) {
    const { children, backurl, title } = props;

    return (
        <div className={styles['vertical-line']}>
            <div>
                <img src="https://service.giveeasy.org/images/giveeasy-alpha_393_100.png" alt="GiveEasy" className={styles['logo-size']} />
            </div>
            <div className={styles['padding-div']}>
                <a href={backurl}>
                    <span>
                        <svg viewBox="0 0 25 25" className="icon icon-chevron-left" aria-hidden="true"><path d="M14.19 16.005l7.869 7.868-2.129 2.129-9.996-9.997L19.937 6.002l2.127 2.129z" /></svg>
                    </span>
                </a>
                <span className={`${styles['comments-title']} ${styles['font-type']}`}>
                    {title}
                </span>
            </div>
            <div className={styles['horizontal-line']} />
            {children}
            <div className={`${styles['horizontal-line']} ${styles['bottom-line']}`} />
        </div>
    );
};

LeftNavigation.propTypes = {
    children: PropTypes.node.isRequired,
    backurl: PropTypes.string.isRequired,
    title: PropTypes.string,
};

LeftNavigation.defaultProps = {
    title: 'Back',
};

export default LeftNavigation;
